<template lang="html">
    <div class="singleImage" v-if="!image">
        <android-file-picker
            :id="'content-image-' + record.ref"
            mode="single"
            type="Image"
            v-if="androidFilePickerOpen"
        ></android-file-picker>
        <label class="plusIcon" @click="openFileAndroid">
            <plus-icon class="icon" />
            <input @change="selectFile" type="file" accept="image/x-png,image/gif,image/jpeg" />
        </label>

        <button
            v-if="editMode"
            class="button red deleteSingleImage"
            @click.prevent="deleteSection"
            type="button"
        >
            <img src="@/assets/minus.svg" class="icon" />
        </button>
    </div>
    <div class="singleImage image" v-else>
        <img @click.prevent="imageIndex = 0" :src="image" />

        <button
            v-if="editMode"
            class="button red deleteSingleImage"
            @click.prevent="deleteSection"
            type="button"
        >
            <img src="@/assets/minus.svg" class="icon" />
        </button>

        <CoolLightBox :items="galleryImages" :index="imageIndex" @close="imageIndex = null">
        </CoolLightBox>
    </div>
</template>

<script>
import AndroidFilePicker from "@/components/Shared/Android-file-picker";
import { imageURL } from "@/mixins/imageURL.js";
import { PlusIcon } from "vue-feather-icons";
import { isAndroid } from "mobile-device-detect";
export default {
    name: "content-image",
    props: ["record", "value", "index", "editMode"],
    mixins: [imageURL],
    components: { PlusIcon, AndroidFilePicker },
    data() {
        return {
            image: false,
            galleryImages: [],
            imageIndex: null,
            oWebViewInterface: window.nsWebViewInterface,
            androidFilePickerOpen: false,
        };
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
    },
    created() {
        if (this.record.image_url) {
            this.image = this.imageURL(this.record.image_url);
            this.galleryImages[0] = this.imageURL(this.record.image_url);
        } else if (this.record.image) {
            this.image = this.record.image;
            this.galleryImages[0] = this.image;
        }

        this.oWebViewInterface.on("fileRecieved-content-image-" + this.record.ref, (imageData) => {
            this.androidFilePickerOpen = false;
            this.inputVal = "data:image/png;base64," + String(imageData);
            this.image = "data:image/png;base64," + String(imageData);
            this.galleryImages[0] = "data:image/png;base64," + String(imageData);
            this.$emit("saveData");
        });
    },
    methods: {
        openFileAndroid() {
            if (isAndroid) {
                this.androidFilePickerOpen = true;
            }
        },
        selectFile(e) {
            //this.inputVal = e.target.files[0];
            //this.image = URL.createObjectURL(e.target.files[0]);
            //this.galleryImages[0] = URL.createObjectURL(e.target.files[0]);

            var reader = new FileReader();

            reader.onload = (readerEvt) => {
                var binaryString = readerEvt.target.result;
                var string = btoa(binaryString);
                this.inputVal = "data:image/png;base64," + String(string);
                this.image = "data:image/png;base64," + String(string);
                this.galleryImages[0] = "data:image/png;base64," + String(string);

                this.$emit("saveData");
            };

            reader.readAsBinaryString(e.target.files[0]);
        },
        deleteSection() {
            this.$emit("sectionDeleted", this.index, this.record);
        },
    },
};
</script>

<style lang="scss" scoped>
img {
    max-width: 100%;
    border-radius: $radius;
    vertical-align: top;
}
.singleImage.image {
    min-height: auto !important;
}
.deleteSingleImage {
    width: 40px !important;
    height: 40px !important;
    border-radius: 8px !important;
    .icon {
        width: 9px;
    }
}
.formGroup {
    position: relative;
}
.button {
    position: absolute;
    right: 10px;
    width: 35px;
    height: 35px;
    padding: 0px;
    top: -10px;
    svg {
        margin-top: -9px;
        left: 8px;
    }
}
</style>
